var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"commonBanner"},[_c('img',{attrs:{"src":_vm.special == null ?  _vm.banner_path: _vm.special.background_path,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }